import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import {
  Grid,
  AccordionSummary,
  AccordionDetails,
  Switch,
  Divider,
  useTheme,
} from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import { ExpandMore } from "@material-ui/icons";
import { read } from "Helpers/LocalStorage";
import {
  deleteGorouhMoshtari,
  getAllGorouhMoshtari,
  UpdateGorouhMoshtariData,
} from "Stores/actions";
import showNotify from "Helpers/Notify";
import Accordion from "@material-ui/core/Accordion";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import * as R from "ramda";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import IsGFormatter from "Components/Table/ActionFormatter/IsGFormatter";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";

function ExpandCustomerGroup({ row, expanded, onChangeExpanded }) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const { dataRelationGroupMoshtari } = useSelector((state) => ({
    dataRelationGroupMoshtari: state.customer.dataRelationGroupMoshtari,
  }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [addRowStatus, setAddRowStatus] = useState({
    charge: false,
    discount: false,
  });
  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: row.Name,
      validation: {
        required: true,
      },
    },
    chargeProfile: {
      type: "percent",
      row: 1,
      value: row.ChargeProfile,
      validation: {
        isPercent: true,
      },
    },
    chargeFitting: {
      type: "percent",
      row: 1,
      value: row.ChargeFitting,
      validation: {
        isPercent: true,
      },
    },
    chargeGlass: {
      type: "percent",
      row: 1,
      value: row.ChargeGlass,
      validation: {
        isPercent: true,
      },
    },
    chargeNet: {
      type: "percent",
      row: 1,
      value: row.ChargeNet,
      validation: {
        isPercent: true,
      },
    },
    chargeOther: {
      type: "percent",
      row: 1,
      value: row.ChargeOther,
      validation: {
        isPercent: true,
      },
    },
    discountProfile: {
      type: "percent",
      row: 2,
      value: row.DiscountProfile,
      validation: {
        isPercent: true,
      },
    },
    discountFitting: {
      type: "percent",
      row: 2,
      value: row.DiscountFitting,
      validation: {
        isPercent: true,
      },
    },
    discountGlass: {
      type: "percent",
      row: 2,
      value: row.DiscountGlass,
      validation: {
        isPercent: true,
      },
    },
    discountNet: {
      type: "percent",
      row: 2,
      value: row.DiscountNet,
      validation: {
        isPercent: true,
      },
    },
    discountOther: {
      type: "percent",
      row: 2,
      value: row.DiscountOther,
      validation: {
        isPercent: true,
      },
    },
  });
  const [showAlert, setShowAlert] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);

  useEffect(() => {
    if (row) {
      let _charge = false;
      let _discount = false;

      if (
        row.ChargeProfile ||
        row.ChargeFitting ||
        row.ChargeGlass ||
        row.ChargeNet ||
        row.ChargeOther
      )
        _charge = true;

      if (
        row.DiscountProfile ||
        row.DiscountFitting ||
        row.DiscountGlass ||
        row.DiscountNet ||
        row.DiscountOther
      )
        _discount = true;

      setAddRowStatus({
        discount: _discount,
        charge: _charge,
      });

      setChange(false);
    }
  }, []);

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const {
      name,
      chargeProfile,
      chargeFitting,
      chargeGlass,
      chargeNet,
      chargeOther,
      discountProfile,
      discountFitting,
      discountGlass,
      discountNet,
      discountOther,
    } = controls;

    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Id: row.Id,
          Name: name.value,
          ChargeProfile: convertToEnglishNumber(chargeProfile.value),
          ChargeFitting: convertToEnglishNumber(chargeFitting.value),
          ChargeGlass: convertToEnglishNumber(chargeGlass.value),
          ChargeNet: convertToEnglishNumber(chargeNet.value),
          ChargeOther: convertToEnglishNumber(chargeOther.value),
          DiscountProfile: convertToEnglishNumber(discountProfile.value),
          DiscountFitting: convertToEnglishNumber(discountFitting.value),
          DiscountGlass: convertToEnglishNumber(discountGlass.value),
          DiscountNet: convertToEnglishNumber(discountNet.value),
          DiscountOther: convertToEnglishNumber(discountOther.value),
        };
        await dispatch(UpdateGorouhMoshtariData(data));
        const params = { KeyGroup: read("groupKey"), KeyUser: read("userKey") };
        await dispatch(getAllGorouhMoshtari(params));
        setLoading(false);
      } catch (e) {
        showNotify({
          text: t("correctFormDataRequired"),
          customClass: "error",
        });
        setLoading(false);
      }
    } else {
      showNotify({
        text: t("correctFormDataRequired"),
        customClass: "error",
      });
    }
  };

  const onShowAlert = () => {
    setShowAlert(!showAlert);
    setDeleteRelationData(null);
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      await dispatch(deleteGorouhMoshtari(data));
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  useEffect(() => {
    setDeleteRelationData(dataRelationGroupMoshtari);
  }, [dataRelationGroupMoshtari]);

  const setRowStatus = (side) => {
    const value = addRowStatus[side];
    setAddRowStatus({
      ...addRowStatus,
      [side]: !value,
    });
  };

  const onChangeAccordion = () => {
    if (expanded !== row.Id) onChangeExpanded(row.Id);
    else onChangeExpanded(-1);
  };

  return (
    <Accordion
      variant="outlined"
      className="overflow-hidden cu-group"
      // expanded={expanded === row.Id}
      // onChange={onChangeAccordion}
    >
      <AccordionSummary expandIcon={<ExpandMore />} className="bg-action">
        <div className="w-100 d-flex align-items-center overflow-hidden g-1">
          <IsGFormatter cell={row.IsG} />
          <div>{row.Name} </div>
        </div>
        <div>
          <MuiIconButton
            disabled={
              (row.IsG && read("StypeU") !== "1") ||
              read("groupCustomerRules").accessDelete === false
            }
            icon={<Icons.Trash3 size={17} />}
            className="danger-fill"
            onClick={onShowAlert}
          />
          <AlertDialog
            showAlert={showAlert}
            type="alertError"
            onClose={onShowAlert}
            onClickOk={onDelete}
            okTitle={<Translator id="ble_pak_shavad" />}
            cancelTitle={<Translator id="enseraf" />}
            questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
            relationText={<Translator id="relationAlert" />}
            relationData={deleteRelationData}
            loading={loading}
          />
        </div>
      </AccordionSummary>
      <AccordionDetails className="details">
        <Grid container spacing={2}>
          <Grid item xs={12} className="px-0 mt-4">
            <Input
              disabled={row.IsG && read("StypeU") !== "1"}
              setValue={setValue.bind(this)}
              name="name"
              defaultValue={row.Name}
              validation={controls.name.validation}
              label={<Translator id="name_groh_jadid" />}
              type="text"
            />
          </Grid>
          <Grid
            item
            xs={12}
            className="new-customer-add-row"
            onClick={() => setRowStatus("charge")}
          >
            <div className="section-details">
              <span className="row-title">
                {t('customer_edit_custom_charge')}
              </span>
              <span className="exp d-none">
                {`پروفیل:${controls.chargeProfile.value} | یراق:${controls.chargeFitting.value} | شیشه:${controls.chargeGlass.value} | توری:${controls.chargeNet.value} | دیگر:${controls.chargeOther.value}`}
              </span>
            </div>
            <Switch
              className={`switcher ${direction}`}
              color="primary"
              checked={addRowStatus.charge}
            />
          </Grid>
          {addRowStatus.charge &&
            Object.keys(controls)
              .filter((key) => controls[key].row === 1)
              .map((key, index) => {
                return (
                  <Grid key={key + index} item sm={4} xs={6}>
                    <Input
                      disabled={row.IsG && read("StypeU") !== "1"}
                      setValue={setValue.bind(this)}
                      name={key}
                      defaultValue={controls[key].value}
                      className="percent"
                      validation={controls[key].validation}
                      label={<Translator id={key} />}
                      type="text"
                      endIcon={"%"}
                    />
                  </Grid>
                );
              })}
          <Divider />
          <Grid
            item
            xs={12}
            className="new-customer-add-row"
            onClick={() => setRowStatus("discount")}
          >
            <div className="section-details">
              <span className="row-title">
                {t('customer_edit_custom_discount')}
              </span>
              <span className="exp d-none">
                {`پروفیل:${controls.discountProfile.value} | یراق:${controls.discountFitting.value} | شیشه:${controls.discountGlass.value} | توری:${controls.discountNet.value} | دیگر:${controls.discountOther.value}`}
              </span>
            </div>
            <Switch
              className={`switcher ${direction}`}
              color="primary"
              checked={addRowStatus.discount}
            />
          </Grid>
          {addRowStatus.discount &&
            Object.keys(controls)
              .filter((key) => controls[key].row === 2)
              .map((key, index) => {
                return (
                  <Grid key={key + index} item sm={4} xs={6}>
                    <Input
                      disabled={row.IsG && read("StypeU") !== "1"}
                      setValue={setValue.bind(this)}
                      name={key}
                      className="percent"
                      defaultValue={controls[key].value}
                      validation={controls[key].validation}
                      label={<Translator id={key} />}
                      type="text"
                      endIcon={"%"}
                    />
                  </Grid>
                );
              })}
          <Grid item xs={12} className="px-0">
            <MuiButton
              loading={loading}
              color="primary"
              title={<Translator id="virayesh" />}
              onClick={onSubmit}
              className="w-100 mt-4"
              disabled={
                !change ||
                (row.IsG && read("StypeU") !== "1") ||
                read("groupCustomerRules").accessUpdate === false
              }
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

export default ExpandCustomerGroup;
